<template>
  <div>
    <el-table
      :data="tableList.list"
      v-loading="loading"
      border
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column label="月份" width="110" align="center">
        <template slot-scope="scope">
          {{ formatStatMonth(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="platformVerifiedPoiSalesAmount"
        label="平台POI已核销券总销售金额"
        min-width="190"
        align="center"
      />
      <el-table-column
        prop="agentVerifiedPoiSalesAmount"
        label="团长已核销券总销售金额"
        min-width="190"
        align="center"
      />
      <el-table-column
        prop="nonCouponTransactionAmount"
        label="平台抖音团购非券订单成交金额(不含关单)"
        min-width="220"
        align="center"
      />
      <el-table-column prop="estimatedCommission" label="预估佣金" min-width="130" align="center" />
      <el-table-column label="实际结算佣金" min-width="140" align="center">
        <template slot-scope="scope">
          {{ formatNullableValue(scope.row.actualSettledCommission) }}
        </template>
      </el-table-column>
      <el-table-column label="结算时间" min-width="180" align="center">
        <template slot-scope="scope">
          {{ formatNullableValue(scope.row.settlementTime) }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="tableList.total > 0"
      class="pagination"
      :current-page="params.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableList.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import poi from '@/api/poi'

const PoiModel = new poi()

export default {
  name: 'NonCouponCommissionList',
  data() {
    return {
      loading: false,
      requestId: 0,
      params: {
        pageNo: 1,
        pageSize: 10
      },
      tableList: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
        list: []
      }
    }
  },
  created() {
    this.getList()
  },
  beforeDestroy() {
    this.requestId += 1
  },
  methods: {
    async getList() {
      const requestId = ++this.requestId
      this.loading = true
      try {
        const res = await PoiModel.getNonCouponCommissionDetailPage({
          userUUID: '',
          pageNo: this.params.pageNo,
          pageSize: this.params.pageSize
        })
        if (requestId !== this.requestId) return
        if (!res || !res.data || res.data.code !== 200) {
          this.restorePagingParams()
          this.$message.error(res && res.data && res.data.message
            ? res.data.message
            : '获取非券订单佣金列表失败')
          return
        }
        const data = res.data.data || {}
        const currentPage = this.normalizePositiveInteger(data.pageNo, this.params.pageNo)
        const pageSize = this.normalizePositiveInteger(data.pageSize, this.params.pageSize)
        this.tableList.list = Array.isArray(data.list) ? data.list : []
        this.tableList.total = this.normalizeNonNegativeNumber(data.total)
        this.tableList.currentPage = currentPage
        this.tableList.pageSize = pageSize
        this.params.pageNo = currentPage
        this.params.pageSize = pageSize
      } catch (error) {
        if (requestId !== this.requestId) return
        this.restorePagingParams()
        const message = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : error && error.message
            ? error.message
            : '获取非券订单佣金列表失败'
        this.$message.error(message)
      } finally {
        if (requestId === this.requestId) {
          this.loading = false
        }
      }
    },
    formatStatMonth(row) {
      if (!row || row.statYear == null || row.statMonth == null) return ''
      return `${row.statYear}年${row.statMonth}月`
    },
    formatNullableValue(value) {
      return value == null ? '' : value
    },
    normalizePositiveInteger(value, fallback) {
      const number = Number(value)
      return Number.isInteger(number) && number > 0 ? number : fallback
    },
    normalizeNonNegativeNumber(value) {
      const number = Number(value)
      return Number.isFinite(number) && number >= 0 ? number : 0
    },
    restorePagingParams() {
      this.params.pageNo = this.tableList.currentPage
      this.params.pageSize = this.tableList.pageSize
    },
    handleSizeChange(value) {
      this.params.pageNo = 1
      this.params.pageSize = value
      this.getList()
    },
    handleCurrentChange(value) {
      this.params.pageNo = value
      this.getList()
    }
  }
}
</script>

<style scoped lang="less">
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/components/nonCouponCommissionList.vue